module.exports = __webpack_public_path__ + "static/img/mode3.0273e0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/mode3.png
// module id = xgMO
// module chunks = 1